export default function LegalShell({ title, lastUpdated, children, pageTestId, seo }) {
  return (
    <div data-testid={pageTestId}>
      {seo}
      <section className="bg-brand-ink text-white">
        <div className="container-page py-16 lg:py-24">
          <p className="label-eyebrow text-brand-green">Legal</p>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl text-balance">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-4 text-white/60 text-sm">Last updated: {lastUpdated}</p>
          )}
        </div>
      </section>

      <section className="container-page py-16 lg:py-20">
        <article
          data-testid="legal-content"
          className="prose-legal max-w-3xl"
        >
          {children}
        </article>
      </section>

      <style>{`
        .prose-legal { color: #0A192F; line-height: 1.75; }
        .prose-legal p { margin-bottom: 1.1rem; color: #334155; }
        .prose-legal h2 { font-family: "Cabinet Grotesk","Manrope",sans-serif; font-weight: 800; font-size: 1.5rem; color: #0A192F; margin-top: 2.5rem; margin-bottom: 1rem; letter-spacing:-0.02em; }
        .prose-legal h3 { font-family: "Cabinet Grotesk","Manrope",sans-serif; font-weight: 700; font-size: 1.15rem; color: #0A192F; margin-top: 1.75rem; margin-bottom: .75rem; }
        .prose-legal ul, .prose-legal ol { padding-left: 1.25rem; margin-bottom: 1.1rem; color: #334155; }
        .prose-legal li { margin-bottom: .5rem; }
        .prose-legal a { color: #1F8B3A; text-decoration: underline; }
        .prose-legal a:hover { color: #166327; }
        .prose-legal strong { color: #0A192F; }
      `}</style>
    </div>
  );
}
